import MBox from './box'

MBox.install = function (Vue) {
  Vue.component(MBox.name, MBox)
}

export default MBox



// WEBPACK FOOTER //
// ./src/m/box/index.js